<div #map class="map" [id]="id">
</div>
<div class="content" id="content">
  <app-corporate-map-popup *ngIf="popupFlag" (closePopup)="closeListingPopup()" [listing]="selectedListing"
    [employee]="selectedEmployee" [booking]="selectedBooking">
  </app-corporate-map-popup>
</div>
